import templateUrl from './wage-policy-history-modal.component.html';

export const WagePolicyHistoryModalComponent = {
    controller: WagePolicyHistoryController,
    controllerAs: "vm",
    templateUrl,
    bindings: {
        resolve: "<",
        close: "&",
        dismiss: "&"
    }
};

export const WagePolicyHistoryModal = {
    component: "apexWagePolicyHistoryModal",
    windowClass: 'xx-dialog pagespinner',
    backdrop: 'static',
    size: 'lg'
};

export function WagePolicyHistoryController(utilityService, wagePolicyService) {
    'ngInject'
    /* jshint validthis:true */
    const vm = this;

    vm.$onInit = $onInit;
    vm.save = save;
    vm.cancel = cancel;
    vm.setDirty = setDirty;
    vm.minEffectiveDate;

    function $onInit() {
        vm.policy = vm.resolve.policy;
        // The min effective date that can be set is no earlier than the start date of the most recent item.
        vm.minEffectiveDate = vm.policy.History.reduce(function (max, item) {
            return item.StartDate > max ? item.StartDate : max;
        }, null) || new Date(1900, 0, 1);
    }

    function save() {
        utilityService.showLoading();
        wagePolicyService.saveWagePolicy(vm.policy)
            .then(function (updatedPolicy) {
                utilityService.hideLoading();
                return vm.close({ $value: updatedPolicy });
            })
            .catch(function (ex) {
                utilityService.hideLoading();
                alert("Save failed: " + (ex.statusText || (ex.message === "" || ex.message ? ex.message : ex)));
            });
    }

    function cancel() {
        vm.dismiss({ $value: 'cancel' });
    }

    function setDirty() {
        vm.dirty = true;
    }
}
